export default __webpack_public_path__ + "static/Twitter-82a81431749bedb632e13b3d293768e4.jpg";